import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

function PDFPage3(props: any) {
  const customerDetails = props?.customerDetails;
  const hcinfo = props?.hcinfo;
  const customerLoanData = props?.customerLoanData?.find(
    (f: any) => f.loan_id === props?.loan_id,
  );
  const [isNewLoans] = useState<any>(["internal_new", "external_new"]);

  const internalExternalText = (text: any, textType: any) => {
    switch (text) {
      case "Reference rate":
        if (isNewLoans.includes(textType)) {
          return props.TranslateString("Requested Euribor");
        } else {
          return props.TranslateString("Reference rate");
        }
      case "Payment type":
        if (isNewLoans.includes(textType)) {
          return props.TranslateString("Requested payment method");
        } else {
          return props.TranslateString("Payment type");
        }
      case "yearly_payments":
        if (isNewLoans.includes(textType)) {
          return props.TranslateString("Requested payment interval");
        } else {
          return props.TranslateString("yearly_payments");
        }
      default:
        break;
    }
  };

  return (
    <>
      <Container fluid className="text-left page-break cu-pt-10">
        <h3 className="cu-fs-18">
          {props.TranslateString("Basic information")}​
        </h3>
        <Row className="px-md-5 ">
          <Col>
            <legend className="cu-fs-16 px-2">
              {props.TranslateString("Company")}
            </legend>
            <hr />
            <ul className="cu-fs-12">
              <li>
                {props.TranslateString("Address")}:{" "}
                {customerDetails?.cust_data_address || "-"}​
              </li>
              <li>
                {props.TranslateString("Business id")}:{" "}
                {customerDetails?.business_id || "-"}​
              </li>
              <li>
                {props.TranslateString("Property type")}:{" "}
                {customerDetails?.cust_data_property_type_group || "-"}
              </li>
              <li>
                {props.TranslateString("Land ownership")}:{" "}
                {customerDetails?.cust_data_ownership_type || "-"} ​
              </li>
              <li>
                {props.TranslateString("Build year")}:{" "}
                {customerDetails?.cust_data_buildyear_org || "-"}
              </li>
              <li>
                {props.TranslateString("Number of buildings")}:{" "}
                {customerDetails?.cust_data_num_buildings || "0"}​
              </li>
              <li>
                {props.TranslateString("Num. of apartments")}:{" "}
                {customerDetails?.cust_data_num_apartments + ", " || "0,"}{" "}
                {props.TranslateString("Apartment m2")}:{" "}
                {customerDetails?.cust_data_apartment_surfacearea || "0"}​
                <ul style={{ listStyle: "circle", listStyleType: "unset" }}>
                  <li>
                    {props.TranslateString("Of which HC owned")}:{" "}
                    {customerDetails?.cust_data_aprt_owned &&
                    customerDetails?.cust_data_aprt_owned !== "NULL"
                      ? customerDetails?.cust_data_aprt_owned
                      : "0"}{" "}
                    {props.TranslateString("kpl")}
                  </li>
                </ul>
              </li>
              <li>
                {props.TranslateString("Number of business spaces")}:{" "}
                {`${customerDetails?.commercial_spaces !== "-" ? customerDetails?.commercial_spaces : "0"} ,` ||
                  "0,"}
                ​ {props.TranslateString("Business space m2")}:{" "}
                {customerDetails?.cust_data_business_surfacearea || "0"}​
                <ul style={{ listStyle: "circle", listStyleType: "unset" }}>
                  <li>
                    {props.TranslateString("Of which HC owned")}:{" "}
                    {customerDetails?.cust_data_business_owned &&
                    customerDetails?.cust_data_business_owned !== "NULL"
                      ? customerDetails?.cust_data_business_owned
                      : "0"}{" "}
                    {props.TranslateString("kpl")}
                  </li>
                </ul>
              </li>
              <li>
                {props.TranslateString("Num of car spaces")}:{" "}
                {customerDetails?.cust_data_num_carspaces &&
                customerDetails?.cust_data_num_carspaces !== "NULL"
                  ? customerDetails?.cust_data_num_carspaces
                  : "0"}
                <ul style={{ listStyle: "circle", listStyleType: "unset" }}>
                  <li>
                    {props.TranslateString("Of which HC owned")}:{" "}
                    {customerDetails?.cust_data_carspace_owned_by_hc &&
                    customerDetails?.cust_data_carspace_owned_by_hc !== "NULL"
                      ? customerDetails?.cust_data_carspace_owned_by_hc
                      : "0"}{" "}
                    {props.TranslateString("kpl")}
                  </li>
                </ul>
              </li>
              <li>
                {props.TranslateString("Other premises")}:{" "}
                {customerDetails?.other_spaces || "0"}​
              </li>
              <li>
                {props.TranslateString("Number of floors")}:{" "}
                {customerDetails?.cust_data_num_floors || "0"}​
              </li>
              <li>
                {props.TranslateString("Housing manager")}:​
                <ul style={{ listStyle: "circle", listStyleType: "unset" }}>
                  <li>{hcinfo.hc_manager_name || "-"}​</li>
                  <li>{hcinfo.hc_manager_phone || "-"}​</li>
                  <li>{hcinfo.hc_manager_email || "-"}​</li>
                </ul>
              </li>
            </ul>
          </Col>
          <Col>
            <legend className="cu-fs-16">
              {props.TranslateString("Tendered Loan")}
            </legend>
            <hr />
            <ul className="cu-fs-12">
              {(() => {
                if (isNewLoans.includes(customerLoanData?.loan_data_info)) {
                  return (
                    <li>
                      {customerLoanData?.construction_loan?.replace(
                        "Uusi laina:",
                        props.TranslateString("new_loan"),
                      ) || ""}
                      ​
                    </li>
                  );
                } else {
                  return <li>{customerLoanData?.construction_loan || ""}​</li>;
                }
              })()}
              <ul style={{ listStyle: "circle", listStyleType: "unset" }}>
                {(() => {
                  if (isNewLoans.includes(customerLoanData?.loan_data_info)) {
                    return "";
                  } else {
                    return (
                      <li>
                        {props.TranslateString("bank_pdf")}:{" "}
                        {customerLoanData?.lender}
                      </li>
                    );
                  }
                })()}
                <li>
                  {props.TranslateString("remaining_capital")}:{" "}
                  {customerLoanData?.remaining_capital} ​
                </li>
                {(() => {
                  if (isNewLoans.includes(customerLoanData?.loan_data_info)) {
                    return "";
                  } else {
                    return (
                      <li>
                        {props.TranslateString("Loan time remaining")}:{" "}
                        {customerLoanData?.remaining_loanperiod?.replace(
                          "years",
                          props.TranslateString("years"),
                        ) || "-"}
                        ​
                      </li>
                    );
                  }
                })()}
                {(() => {
                  if (isNewLoans.includes(customerLoanData?.loan_data_info)) {
                    return "";
                  } else {
                    return (
                      <li>
                        {props.TranslateString("Margin")}:{" "}
                        {customerLoanData?.margin || "-"}​
                      </li>
                    );
                  }
                })()}
                <li>
                  {internalExternalText(
                    "Reference rate",
                    customerLoanData?.loan_data_info,
                  )}
                  : {customerLoanData?.reference_interest_rate || "-"}​
                </li>
                <li>
                  {internalExternalText(
                    "Payment type",
                    customerLoanData?.loan_data_info,
                  )}
                  : {customerLoanData?.shortening_period || "-"}
                </li>
                <li>
                  {internalExternalText(
                    "yearly_payments",
                    customerLoanData?.loan_data_info,
                  )}
                  : {customerLoanData?.yearly_payments || "-"}
                </li>
                <li>
                  Toivottu laina-aika: 
                   {customerLoanData?.loan_tender_time
                    ? ` ${customerLoanData.loan_tender_time} vuotta`
                    : "-"}
                </li>
                {(() => {
                  if (
                    isNewLoans.includes(customerLoanData?.loan_data_info) &&
                    customerLoanData?.loan_data_purpose
                  ) {
                    return (
                      <li>
                        <div className="pre d-flex">
                          <span>
                            {props.TranslateString("Purpose of the loan")}:{" "}
                          </span>
                          <span>
                            {customerLoanData?.loan_data_purpose || "-"}​
                          </span>
                        </div>
                      </li>
                    );
                  }
                })()}
              </ul>
            </ul>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PDFPage3;
